import "./es.object.assign-7e79fd7b.js";
import { c } from "./index-8b07dec9.js";
import a, { css as u } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "react";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as n } from "./getMetrics-953aa4f8.js";
import { jsx as d } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
var D = "DISCLOSURE_CONTENT_TEST_ID", T = /* @__PURE__ */ a.div.withConfig({
  displayName: "disclosure__StyledDisclosures",
  componentId: "sc-10jgb2x-0"
})(["&.Disclosures{", ";}"], function(s) {
  var o = s.theme.components.disclosure;
  return u(o.Disclosure);
}), Q = function(o) {
  var r = o.id, t = o.disclosureContent, i = o.disclosureTitleColor, m = o.className, e = o.style, l = n({
    label: "Disclosure"
  }), p = {
    color: i
  };
  return /* @__PURE__ */ d(T, Object.assign({
    id: r,
    "data-testid": D + "_disclosure_content",
    className: c(["Disclosures", m]),
    style: Object.assign({}, p, e)
  }, l, {
    children: t
  }));
};
export {
  Q as Disclosures
};
